// LIST
export const GET_WARNINGS = "app/WARNINGS/GET_WARNINGS";
export const GET_WARNINGS_SUCCESS = "app/WARNINGS/GET_WARNINGS_SUCCESS";
export const GET_WARNINGS_FAILURE = "app/WARNINGS/GET_WARNINGS_FAILURE";

export const SAVE_WARNING = "app/WARNINGS/SAVE_WARNING";
export const SAVE_WARNING_SUCCESS = "app/WARNINGS/SAVE_WARNING_SUCCESS";
export const SAVE_WARNING_FAILURE = "app/WARNINGS/SAVE_WARNING_FAILURE";

export const UPDATE_WARNING = "app/WARNINGS/UPDATE_WARNING";
export const UPDATE_WARNING_SUCCESS = "app/WARNINGS/UPDATE_WARNING_SUCCESS";
export const UPDATE_WARNING_FAILURE = "app/WARNINGS/UPDATE_WARNING_FAILURE";
